import { EFrontElement } from "$src/CGS/domain/dto/core/EFrontElement";
import { ECabinetGeneratorErrorCode } from "./ECabinetGeneratorErrorCode";

export class CabinetGeneratorError {
    /// <summary>
    /// Error code
    /// </summary>
    public code: ECabinetGeneratorErrorCode;

    public availableLength: number;

    public actualLength: number;

    public frontElement: EFrontElement;

    constructor(
        code: ECabinetGeneratorErrorCode,
        availableLength: number,
        actualLength: number,
        frontElement: EFrontElement
    ) {
        this.code = code;
        this.availableLength = availableLength;
        this.actualLength = actualLength;
        this.frontElement = frontElement;
    }
}
